// src/components/protected-route.tsx
import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedRoute() {
  const isAuthenticated = !!localStorage.getItem("token");
  // const session = JSON.parse(sessionStorage.getItem("adminData") || "{}");
  // const expiresAt = session.authentication.expiresAt;
  // console.log(expiresAt);
  const currentTime = Math.floor(Date.now() / 1000);
  // if (!isAuthenticated && currentTime > expiresAt) {
  if (!isAuthenticated) {
    localStorage.clear();
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
